import React from 'react'
import AppRoutes from './routes/AppRoutes'
import { AuthProvider } from './modules/auth/authContext'

const App: React.FC = () => {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  )
}

export default App
